/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { assertString } from '../isCreditCard';
import merge from '../mergeObject';

const defaultIsEmptyOptions = {
  ignoreWhitespace: false,
};

export default function isEmpty(str: string, options?: any) {
  assertString(str);
  options = merge(options, defaultIsEmptyOptions);

  return (options.ignoreWhitespace ? str.trim().length : str.length) === 0;
}
